import axios from 'axios'
import { useAuthContext } from './useauthContext'
import Cookies from 'js-cookie'
import { API_URL } from '../config';

export const useLogout = () => {
  const { dispatch } = useAuthContext()

  const logout = async () => {
    try {
      // Call the backend logout endpoint.
      // withCredentials may be required if your backend uses cookies.
      const response = await axios.post(`${API_URL}/logout`, {}, { withCredentials: true })
      console.log(response.data.message)
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      // Remove user data from local storage
      localStorage.removeItem('user')
      localStorage.removeItem('token')

      // Remove the cookie by matching the domain and path used when setting it
      Cookies.remove('user', { domain: 'robofication.com', path: '/' });

      // Dispatch logout action to update context
      dispatch({ type: 'LOGOUT' })
    }
  }

  return { logout }
}
